<template>
    <div>
        <div class="row">
            <div class="col-sm-12">
                <div>
                    <div class="content center-block">
                        <div class="row">
                            <div class="col-sm-12">
                                <div>
                                    <div class="pull-right mb-10 col-sm-7">
                                        <button class="btn btn-success pull-right" v-if="$can('btonly')" @click="showAddJobModal()">Vacature toevoegen</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div v-for="job in filteredJobs" class="center-block well mb-20 job-container text-center">
                                <h1>{{ getLocale() == 'nl' ? job.dutchTitle : job.frenchTitle}}</h1>
                                <div class="row">
                                    <div class="col-sm-12">
                                        <p style="white-space: pre-wrap;">{{ getLocale() == 'nl' ? job.dutchDescription : job.frenchDescription }}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-1 col-sm-offset-5">
                                        <i v-if="_self.$can('btonly')" class="glyphicon glyphicon-edit" @click="editJob(job.id)"></i>
                                    </div>
                                    <div class="col-sm-1">
                                        <i v-if="_self.$can('btonly')" class="glyphicon glyphicon-trash" @click="deleteJob(job.id)"></i>
                                    </div>
                                </div>
                            </div>
                            <div v-if="filteredJobs.length === 0" class="col-sm-12 text-center">
                                Momenteel zijn er geen vacatures
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <bt-footer />
    </div>
</template>

<script>
    import BtFooter from './BTFooter.vue'
    import { mapGetters } from 'vuex'
    import * as types from '../store/mutation-types'

    export default {
        name: 'Jobs',
        data() {
            return {
                BACKEND_BASE_URL: process.env.VUE_APP_BACKEND_BASE_URL,
            }
        },
        created() {
            document.title = 'Brabant-Tools | Vacatures'
            this.$store.dispatch('getJobs')
        },
        methods: {
            getLocale() {
                return this.$i18n.locale
            },
            editJob(jobId) {
                this.$modal.show('edit-job-modal', { jobId: jobId })
            },
            deleteJob(jobId) {
                this.$swal({
                    title: 'Let op!',
                    text: 'Je staat op het punt om een vacature te verwijderen. Deze actie kan niet ongedaan worden!',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Verwijderen',
                    cancelButtonText: 'Annuleren'
                }).then((result) => {
                    if (result) {
                        //this.$store.commit(types.REMOVE_JOB_FROM_JOBS, jobId)
                        this.$store.dispatch('deleteJob', jobId)
                    }
                })
            },
            showAddJobModal() {
                this.$modal.show('add-job-modal')
            },
        },
        computed: {
            ...mapGetters({
                isJobCreated: 'isJobCreated',
                jobs: 'jobs',
                isAdmin: 'isAdmin'
            }),
            filteredJobs() {
                return this.jobs.filter(job => {
                    return (job.active || this.isAdmin)
                })
            }
        },
        components: {
            BtFooter
        }
    }
</script>

<style scoped>
    .glyphicon {
        cursor: pointer;
    }

    .job-container {
        width: 800px;
        box-shadow: 5px 5px 5px grey;
    }

        .job-container h1 {
            color: red;
            font-weight: bold;
        }
</style>